import moment, { Moment } from 'moment-timezone';

import { DayOfWeekTimeslot } from '../../fetching/sharedSchemas/basicSchemas';

export class AxleTime {
    hours: number;
    minutes: number;

    constructor(hours: number, minutes: number) {
        if (hours < 0 || hours > 23) {
            throw new Error('Hours must be between 0 and 23');
        }
        if (minutes < 0 || minutes > 59) {
            throw new Error('Minutes must be between 0 and 59');
        }
        this.hours = hours;
        this.minutes = minutes;
    }

    public toIsoTimeString(): string {
        return `${this.hours.toString().padStart(2, '0')}:${this.minutes
            .toString()
            .padStart(2, '0')}:00`;
    }

    public toDisplayString(timezone?: string): string {
        const amPm = this.hours >= 12 ? 'pm' : 'am';
        const hours12 = this.hours % 12 || 12;
        return `${hours12}:${this.minutes.toString().padStart(2, '0')} ${amPm} ${
            timezone ? moment.tz(timezone).zoneAbbr() : ''
        }`;
    }

    public compareTo(otherTime: AxleTime): number {
        const thisTotalMinutes = this.hours * 60 + this.minutes;
        const otherTotalMinutes = otherTime.hours * 60 + otherTime.minutes;
        return thisTotalMinutes - otherTotalMinutes;
    }
}

export const axleTimeFromStr = (isoTimeString: string): AxleTime => {
    const [hours, minutes] = isoTimeString.split(':').slice(0, 2).map(Number);
    return new AxleTime(hours, minutes);
};

export const axleTimeFromMoment = (momenObj: Moment, timezone: string): AxleTime => {
    const momentInTz = momenObj.clone().tz(timezone);
    return new AxleTime(momentInTz.hour(), momentInTz.minute());
};

export const serializeDayOfWeekTimeslot = (
    dayOfWeekTimeslot: DayOfWeekTimeslot | null,
): Record<string, number | string> | null => {
    if (dayOfWeekTimeslot === null) {
        return null;
    }
    return {
        day_of_week: dayOfWeekTimeslot.day_of_week, // must be number
        start_time: dayOfWeekTimeslot.start_time.toIsoTimeString(), // must be iso time string
        end_time: dayOfWeekTimeslot.end_time.toIsoTimeString(), // must be iso time string
    };
};

export const timeZoneOffsetBetweenLocalAndVisitInHours = (visitTimezone: string): number => {
    const visitOffset = moment.tz(visitTimezone).utcOffset();
    const localOffset = -1 * new Date().getTimezoneOffset();
    return (visitOffset - localOffset) / 60;
};
